import gql from 'graphql-tag';

export const UPDATE_FEEDBACK_MUTATION = gql`
mutation updateFeedbackUpdateFeedbackMutation($id: ID!, $answers: [AnswerInput]!, $detailFillIn: Boolean, $feedbackType: String, $okrId: Int, $badgeId: Int) {
  updateFeedback(id: $id, answers: $answers, detailFillIn: $detailFillIn, feedbackType: $feedbackType, okrId: $okrId, badgeId: $badgeId) {
    feedback {
      id
      badgeAward: badge {
        id
      }
    }
  }
}
`;
